export const UserType = {
  Admin: 'Admin',
  Client: 'Client',
  Jobseeker: 'Jobseeker',
  Supplier: 'Supplier',
};
